<template>
  <div class="cultureBreed cultureBreedContainer">
     <div class="content-container">
      <div class="titieMian">
        <div class="title-container">养殖品种设置</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>查找&nbsp;&nbsp;</span>
            <el-input placeholder="请输入关键字" v-model="keyword" prefix-icon="el-icon-search" size="small" type="text" :maxlength="20" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" class="search-input" clearable>
            </el-input>
          </div>
          <div class="select-container-box">
            <el-button size="small" type="info" plain @click="goSearch()" class="query" >查询</el-button>
            <el-button size="small" type="info" plain @click="goAdd()" class="add" v-if="edit">增加</el-button>
            <!-- <el-button size="small" type="info" plain @click="goSync" class="tongbu" v-if="$store.state.curCompany.isQlwVersion==true&&edit">同步</el-button> -->
          </div>
          <!-- 添加 -->
          <el-dialog :title="titleName"  :visible.sync="dialogFormVisible" v-if="dialogFormVisible"  width="766px" >
            <!-- <div :class="{'content-form-container':true,'readonly':!edit}"> -->
              <el-form :model="form" :rules="rules" ref="form" class="form">
                <el-form-item label="养殖品种" :label-width="formLabelWidth" required>
                  <el-col :span="10">
                    <el-form-item prop="fishCategoryName" style="width:100%;">
                      <el-select v-model="form.fishCategoryName" filterable :disabled="!edit" placeholder="请选择鱼种类型" class="fishType" @change="changeFishGetCategory">
                        <el-option v-for="item in fishGetCategory" :key="item.key" :label="item.value" :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="1">&nbsp;</el-col>
                  <el-col :span="11">
                    <el-form-item  prop="fishName"  style="width:100%;">
                      <el-select v-model="form.fishName" filterable :disabled="!edit" @change="getFishName" placeholder="请选择鱼种名称" class="fishName">
                        <el-option v-for="item in fishGetCategoryName" :key="item.key" :label="item.value" :value="item.key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                <el-form-item label="别名" :label-width="formLabelWidth" style="margin-top: 15px;">
                  <el-col :span="14">
                    <el-input placeholder="请输入别名" v-model="aliasName" :disabled="!edit" clearable />
                  </el-col>
                </el-form-item>
                <el-form-item label="饵料系数" prop="foodCoefficient" :label-width="formLabelWidth" style="margin-top: 15px;">
                  <el-col :span="14">
                    <el-input placeholder="请输入饵料系数" v-model="form.foodCoefficient" :disabled="!edit" clearable />
                  </el-col>
                </el-form-item>
                <el-form-item label="市场价" prop="marketPrice" :label-width="formLabelWidth" style="margin-top: 15px;">
                  <el-col :span="14">
                    <el-input placeholder="请输入市场价" v-model="form.marketPrice" :disabled="!edit" clearable />
                  </el-col>
                </el-form-item>
                <el-form-item v-show="0"  label="计量单位" :label-width="formLabelWidth" required>
                  <el-col :span="12">
                    <el-form-item  prop="unit" style="width:100%;" >
                      <el-select v-model="form.unit" filterable placeholder="请选择计量单位" class="unit" :disabled="!edit">
                        <el-option v-for="item in measurementUnitList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-form-item>
              
                <el-form-item  v-show="0" label="换算系数" :label-width="formLabelWidth" required>
                  <el-col :span="6">
                    <el-form-item  prop="numer" >
                      <el-input value="1" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="1"> &nbsp;</el-col>
                  <el-col class="line" :span="2" >
                    <span style="position:relative;top:7px;">{{form.unit?form.unit:'尾'}}</span>
                  </el-col>
                  <el-col class="line" :span="2">
                    <span style="position:relative;top:7px;">=</span>
                  </el-col>
                  <el-col :span="6" :offset="0.5">
                    <el-form-item  prop="scaling" >
                      <el-input v-model="form.scaling" :disabled="!edit"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="1"> &nbsp;</el-col>
                  <el-col class="line" :span="1" > 
                    <span style="position:relative;top:7px;">尾</span>
                  </el-col>
                </el-form-item>
                <!-- <div style="display:flex;justify-content: space-between;padding-right:85px;"> -->
                  <el-form-item label="是否为主养品种" class="choose-classify">
                    <el-radio-group v-model="form.isMain" :disabled="!edit">
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="是否为吃料品种" class="choose-classify">
                    <el-radio-group v-model="form.canEat" :disabled="!edit">
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                <!-- </div> -->
                
              </el-form>
              
              
            <!-- </div> -->
            <div slot="footer" class="dialog-footer" v-if="edit">
              <el-button @click="cancel('form')" >取 消</el-button>
              <el-button type="primary" @click.native="save('form')" v-if="this.titleName === '添加养殖品种信息'">保 存</el-button>
              <el-button type="primary" @click="saveEdit('form')" v-if="this.titleName === '编辑养殖品种信息'">保 存</el-button>
            </div>
          </el-dialog> 
        </div>
      </div>
      <div class="table-container">
        <el-table
         :data="cultureBreedList.list"
          style="width:100%" 
          size="medium" 
          @row-dblclick="dataBackFillGoods"
          :default-sort="{prop: 'date', order: 'descending'}">
           <i slot="empty" style="font-style:normal">暂无数据</i>
           <el-table-column 
            prop="type" 
            label="品种类别" 
            :filters="getFilterTypeList"
            :filter-method="filterHandler"
            show-overflow-tooltip 
            align="center">
          </el-table-column>
          <el-table-column
           prop="name" 
           label="品种名称" 
           align="center"
           :filters="getFilterNameList"
          :filter-method="filterHandler"
           show-overflow-tooltip 
          >
          </el-table-column>
          <el-table-column 
          prop="foodCoefficient" 
          label="饵料系数" 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="isMain" 
          label="主养品种" 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="canEat" 
          label="吃料品种" 
          align="center">
           <template slot="header">
            <span style="font-size:14px;color:#666;font-weight:bold;">吃料品种</span>
            <el-tooltip effect="dark" placement="top" content="是吃料品种则代表需要消耗鱼料，将计算饵料系数；不是吃料品种代表吃浮游生物为主，将不计算该品种的饵料系数。" >
              <img style="position: absolute;margin-left: 8px;margin-top: 15px;cursor: pointer;" src="../../../../../public/img/icon_prompt.png" alt="">
            </el-tooltip>
          </template>
          </el-table-column>
          <el-table-column 
          prop="marketPrice" 
          label="市场价" 
          align="center">
          </el-table-column>
          <el-table-column label="操作栏" align="center"  >
            <template slot-scope="scope">
              <span @click="handleEdit(scope.$index, scope.row)" class="content-edit">{{edit?"编辑":"查看"}}</span>
              <span @click="handleDel(scope.$index, scope.row)" class="content-del" v-if="edit">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
    </div>
  </div>
</template>


<script>
import { MessageBox, Message } from "element-ui";
import PageChange from "../../../common/PageChange";
import { mapActions, mapState, mapMutations } from "vuex";
import { modules } from "../../../../store";
import checkPermission from "../../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "cultureBreed",
  mixins: [mixins],
  components: {
    PageChange
  },
  data() {
    return {
      titleName: "",
      dialogFormVisible: false,
      fishCategoryList: "", // 鱼分类选择监听列表
      form: {
        unit: "",
        fishCategoryId: "", // 鱼分类名称
        fishCategoryName: "",
        fishId: "", // 鱼ID
        fishName: "", // 鱼名称
        fishStockAbstract: 10000,
        spec: "string",
        speciesId: "",
        isMain: true,
        canEat: true,
        foodCoefficient:'',
        marketPrice:''
      },
      aliasName: "", // 别名
      id: "",
      rules: {
        fishCategoryName: [
          {
            required: true,
            message: "请选择分类品种",
            trigger: "change"
          }
        ],
        fishName: [
          {
            required: true,
            message: "请选择品种名称",
            trigger: "change"
          }
        ],
        unit: [
          {
            required: true,
            message: "请选择计量单位",
            trigger: "change"
          }
        ],
        foodCoefficient:[
           { validator: this.validateNumber, trigger: 'blur' }
        ], 
        marketPrice:[
           { validator: this.validateNumber, trigger: 'blur' }
        ], 
        // scaling: [
        //   {
        //     required: true,
        //     message: "请输入换算系数",
        //     trigger: "blur"
        //   }
        // ]
      },
      formLabelWidth: "140px",
      keyword: "", // 关键字
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.goSearch, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      },
      measurementUnitList: [
        {
          id: 1,
          name: "尾"
        }
      ] //计量单位
    };
  },

  computed: {
    ...mapState(modules.cultureBreed, ["cultureBreedList"]),
    ...mapState(modules.fish, ["fishGetCategory", "fishGetCategoryName"]), //养殖品种
    //需要筛选的字段
    getFilterTypeList() {
      const res = new Map();
      let fiterList = this.cultureBreedList.list
        .map(m => ({
          value: m.type,
          text: m.type
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    //需要筛选的字段
    getFilterNameList() {
      const res = new Map();
      let fiterList = this.cultureBreedList.list
        .map(m => ({
          value: m.name,
          text: m.name
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    }
  },
  async mounted() {
    console.log(mixins, this.curCompany, 111);
    this.goSearch();
  },
  methods: {
    ...mapActions(["getCurCompany"]),
    ...mapActions(modules.dataDict, ["getMeasurementUnit"]), //计量单位
    ...mapActions(modules.cultureBreed, [
      "getCultureBreedData", //查询
      "delCultureBreedList", //删除
      "addCultureBreed", //添加
      "editCultureBreed", //编辑
      "updateCultureBreed", //更新
      "syncBreed" //同步
    ]),
    ...mapActions(modules.fish, [
      "getFishGetCategory", // 获取渔种信息
      "getFishGetCategoryName" // 获取分类渔种名称
    ]),
    ...mapMutations(modules.cultureBreed, ["setDialogFormVisibles"]),
    // 字段筛选过滤
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    //获取鱼分类下得鱼种
    getFishNameData() {
      this.getFishGetCategory()
        .then(rsp => {
          let names = rsp.data.find(
            item => item.value == this.form.fishCategoryName
          );
          this.getFishGetCategoryName(names.key);
        })
        .catch(err => {
          console.dir(err);
        });
    },
    //分类渔种---
    changeFishGetCategory(val) {
      this.form.fishCategoryName = val.value;
      this.form.fishCategoryId = val.key;
      this.getFishGetCategoryName(this.form.fishCategoryId)
        .then(rsp => {
          if (rsp.status === 200) {
            this.form.fishName = "";
            this.form.fishId = "";
          }
        })
        .catch(err => {
          console.dir(err);
        });
      this.aliasName = ''
    },
    getFishName(val) {
      this.aliasName = this.fishGetCategoryName.find( item => item.key === val).value
    },
    //查询
    async goSearch(pageNum) {
      let obj = {
        pageIndex: (this.pageInfo.pageNumber = pageNum || 1),
        pageSize: this.pageInfo.pageSize,
        fishStockAbstract: 10000,
        queryString: this.keyword
      };
      this.getCultureBreedData(obj)
        .then(rsp => {
          if (rsp.status === 200) {
            this.pageInfo.totalPages = rsp.data.total;
          }
        })
        .catch(err => {
          console.dir(err);
        });
    },
    //双击进入编辑页面
    async dataBackFillGoods(row, event) {
      this.dialogFormVisible = true;
      // if (this.edit) {
      //   this.titleName = "编辑养殖品种信息";
      // } else {
      //   this.titleName = "查看养殖品种信息";
      // }
      if (this.$store.state.curCompany.isQlwVersion == true) {
        this.titleName = "编辑养殖品种信息";
      } else if (
        this.$store.state.curCompany.isQlwVersion == false &&
        this.edit == true
      ) {
        this.titleName = "编辑养殖品种信息";
      } else if (
        this.$store.state.curCompany.isQlwVersion == false &&
        this.edit == false
      ) {
        this.titleName = "查看养殖品种信息";
      }

      let result = await this.editCultureBreed(row.id);
      this.form.fishCategoryName = result.type;
      await this.getFishNameData();
      // this.form.fishName = result.name;
      this.form.fishName = result.speciesId;
      this.form.fishStockAbstract = result.fishStockAbstract;
      this.form.unit = "尾";
      this.form.scaling = result.scaling;
      this.form.spec = result.spec;
      this.id = row.id;
      this.form.canEat = result.canEat;
      this.form.isMain = result.isMain;
      this.form.foodCoefficient = result.foodCoefficient;
      this.form.marketPrice = result.marketPrice;
      this.aliasName = result.aliasName;
    },
    //获取编辑数据
    async handleEdit(index, row) {
      this.dialogFormVisible = true;
      if (this.$store.state.curCompany.isQlwVersion == true) {
        this.titleName = "编辑养殖品种信息";
      } else if (
        this.$store.state.curCompany.isQlwVersion == false &&
        this.edit == true
      ) {
        this.titleName = "编辑养殖品种信息";
      } else if (
        this.$store.state.curCompany.isQlwVersion == false &&
        this.edit == false
      ) {
        this.titleName = "查看养殖品种信息";
      }
      let result = await this.editCultureBreed(row.id);
      this.form.fishCategoryName = result.type;
      await this.getFishNameData();
      // this.form.fishName = result.name;
      this.form.fishName = result.speciesId;
      this.form.fishStockAbstract = result.fishStockAbstract;
      this.form.unit = "尾";
      this.form.scaling = result.scaling;
      this.form.spec = result.spec;
      this.id = row.id;
      this.form.canEat = result.canEat;
      this.form.isMain = result.isMain;
      this.form.foodCoefficient = result.foodCoefficient;
      this.form.marketPrice = result.marketPrice;
      this.aliasName = result.aliasName;
    },
    //同步
    goSync() {
      this.syncBreed()
        .then(rsp => {
          if (rsp.status == 200) {
            this.$message({
              message: "同步成功",
              type: "success"
            });
            this.goSearch();
          }
        })
        .catch(err => {
          console.dir(err.response.data);
        });
    },
    // 添加
    async goAdd(formName) {
      this.dialogFormVisible = true;
      this.titleName = "添加养殖品种信息";
      await this.getFishNameData();
      this.form = {
        fishName: "",
        fishCategoryName: "",
        fishStockAbstract: "",
        unit: "尾",
        scaling: "1",
        spec: "",
        speciesId: "",
        isMain: true,
        canEat: true,
        foodCoefficient:'',
        marketPrice:''
      };
      this.$store.commit('fish/setFishGetCategoryName', [])
      this.aliasName = ''
    },
    closeDialog(formRule) {
      this.$refs[formRule].resetFields();
    },
    //取消
    cancel(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
      this.form = {
        fishName: "",
        fishCategoryName: "",
        fishStockAbstract: "",
        unit: "",
        scaling: "",
        spec: "",
        speciesId: "",
        isMain: true,
        canEat: true,
        foodCoefficient:'',
        marketPrice:''
      };
    },
    //删除
    handleDel(index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await this.delCultureBreedList(row.id);
          this.goSearch(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });

          // this.$message.error(err.response.data);
        });
    },
    //添加页---保存
    save(formName) {
      console.log(3333, this.form.isMain);
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            name: this.form.fishName,
            type: this.form.fishCategoryName,
            fishStockAbstract: 10000,
            unit: this.form.unit,
            scaling: this.form.scaling,
            speciesId: this.form.fishName,
            isMain: this.form.isMain,
            foodCoefficient: this.form.foodCoefficient,
            marketPrice: this.form.marketPrice,
            canEat: this.form.canEat,
            aliasName: this.aliasName,
            spec:
              this.form.scaling +
              "尾" +
              "/" +
              (this.form.unit ? this.form.unit : "尾")
          };
          this.addCultureBreed(obj)
            .then(rsp => {
              // this.setDialogFormVisibles(false);
              this.$message({
                message: "保存成功",
                type: "success"
              });

              this.form = {
                fishName: "",
                fishCategoryName: "",
                fishStockAbstract: "",
                unit: "",
                scaling: "",
                spec: "",
                speciesId: "",
                foodCoefficient: '',
                marketPrice: '',
                isMain: true,
                canEat: true
              };
              this.dialogFormVisible = false;
              this.goSearch();
              this.$refs[formName].resetFields();
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
              // this.$message.error(err.response.data);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //修改数据
    saveEdit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            id: this.id,
            name: this.form.fishName,
            type: this.form.fishCategoryName,
            fishStockAbstract: 10000,
            unit: "尾",
            scaling: this.form.scaling,
            speciesId: this.form.fishName,
            isMain: this.form.isMain,
            foodCoefficient: this.form.foodCoefficient,
            marketPrice: this.form.marketPrice,
            canEat: this.form.canEat,
            aliasName: this.aliasName,
            spec:
              this.form.scaling +
              "尾" +
              "/" +
              (this.form.unit ? this.form.unit : "尾")
          };
          let result = this.updateCultureBreed(obj);
          result
            .then(rsp => {
              // this.setDialogFormVisible(false);
              this.$message({
                message: "保存成功",
                type: "success"
              });
              this.form = {
                fishName: "",
                fishCategoryName: "",
                fishStockAbstract: "",
                unit: "",
                scaling: "",
                spec: "",
                speciesId: "",
                isMain: true,
                foodCoefficient: '',
                marketPrice: '',
                canEat: true
              };
              this.dialogFormVisible = false;
              this.goSearch(Number(localStorage.getItem("pageNumber")));
              this.$refs[formName].resetFields();
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
              // this.$message.error(err.response.data);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    validateNumber (rule, value, callback) {
      if (value !== 0 && !value) {
        callback();
      } else if (isNaN(value)) {
        callback(new Error('该值只能是数值类型'));
      } else if (value <= 0) {
        callback(new Error('请输入大于0的数值'));
      } else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        callback(new Error('小数点后最多两位小数'));
      } else {
        callback();
      }
    },
  }
};
</script>

<style>
.cultureBreedContainer .el-form-item__error{
 padding-top: 0px;
 padding-left:40px;
}
</style>
<style lang="stylus">
.el-tooltip__popper{
  line-height:1.3;
  color:#fff;
  font-size:14px;
  max-width:300px;
  
}
.cultureBreed
  .el-form
    padding-left:30px;
  .el-form-item
    margin-bottom:0;
  .choose-classify
    display:flex;
    align-items:center;
    margin-top:10px;
    .el-dialog .el-form-item__content
      bottom:-4px !important;
    .el-form-item__content
      margin-left:18px;
  .el-form .el-form-item .el-form-item__label:before
    left:-30px;
    color: #ff3817;
    font-size:18px;
  .el-dialog
    border-radius:6px;
    overflow:hidden;
    // height:440px;
    border-radius:6px;
    .el-dialog__header 
      padding: 8px 20px 8px;
      border-radius:6px 6px 0px 0px;
      background:linear-gradient(270deg,rgba(51,137,255,1),rgba(31,156,244,1),rgba(49,170,255,1));
      .el-dialog__title 
        color: #fff;
    .el-form-item__content
      line-height: 40px;
      position: relative;
      bottom:-5px;
      font-size: 16px;
      
    .el-dialog__footer
      text-align left
      position relative
      bottom:12px;
      padding:5px 205px 20px
      // margin-bottom:20px;
    .el-button--primary
      margin-left:-10px
      background: #3389ff;
    .el-button .el-button--default
      // margin-left:60px;
    .el-button
      width 100px
      height 40px
      margin-left:24px
    .el-dialog__close 
      color:#fff
    .el-form .el-form-item .el-form-item__label
      margin-top:10px;
      margin-left:40px;
      font-size:16px;
    .ruleForm
      margin-left 0px
    .el-select.unit .el-input__inner
      width:500px!important;
    .el-select.fishType .el-input__inner
       width:210px!important;
    .el-select.fishName .el-input__inner
       width:210px!important;
       margin-left:-35px;
  </style>
